import theme from 'src/theme';

export const durations = {
  width: theme.animation.duration,
  height: theme.animation.duration,
  images: 500,
};

export const duration = durations.width + durations.height + durations.images;
export const delay = 0;
export const durationEnd = delay + duration;

const top = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '50vh',
  backgroundColor: '#f5f5f5',
};

const imgBgLeft = {
  ...(theme.mixins.animation.transition('bottom')),

  position: 'absolute',
  bottom: -80,
  left: '1%',
  width: '25%',
  textAlign: 'left',

  '@global img': {
    maxWidth: '100%',
    maxHeight: 240,
  },

  [theme.breakpoints.down('md')]: {
    bottom: -60,
  },

  [theme.breakpoints.down('sm')]: {
    bottom: -40,
  },
};

const imgBgRight = {
  ...(theme.mixins.animation.transition('bottom')),

  position: 'absolute',
  bottom: -110,
  right: 0,
  width: '25%',
  textAlign: 'right',

  '@global img': {
    maxWidth: '100%',
    maxHeight: 320,
  },

  [theme.breakpoints.down('md')]: {
    bottom: -75,
  },

  [theme.breakpoints.down('sm')]: {
    bottom: -50,
  },
};

export default {
  background: {
    position: 'relative',
    flex: [0, 0, '0px'],
    zIndex: 0,
  },

  top,
  imgBgLeft,
  imgBgRight,

  images: {
    '& $imgBgLeft': imgBgLeft,
    '& $imgBgRight': imgBgRight,
  },

  topAppear: {
    transition: `
    width ${durations.width}ms ${theme.animation.timingFunction} ${delay}ms,
    left ${durations.width}ms ${theme.animation.timingFunction} ${delay}ms,
    height ${durations.height}ms ${theme.animation.timingFunction} ${delay + durations.width}ms`,

    left: '50%',
    width: 0,
    height: 3,
  },

  topAppearActive: {
    left: top.left,
    width: top.width,
    height: top.height,
  },

  imagesAppear: {
    '& $imgBgLeft': {
      ...(theme.mixins.animation.transitionDuration(durations.images, 'left')),
      transitionDelay: `${delay + durations.width}ms`,

      left: '-30%',
    },

    '& $imgBgRight': {
      ...(theme.mixins.animation.transitionDuration(durations.images, 'right')),
      transitionDelay: `${delay + durations.width}ms`,

      right: '-25%',
    },
  },

  imagesAppearActive: {
    '& $imgBgLeft': {
      left: imgBgLeft.left,
    },

    '& $imgBgRight': {
      right: imgBgRight.right,
    },
  },
};
